@if (folderFormId || folderFormData) {
    <div class="gaps-between-sections">
        <div class="grid-2col input-grid-gaps">
            <div class="fr-2 font-bold">{{ 'form.evaluation' | translate }}</div>
            @for (key of keys.slice(0, 4); track key) {
                <app-select-input
                    [id]="key"
                    [form]="form"
                    [staticOptions]="options"
                    [label]="'form.dekn.fields.' + key"
                    [valueKey]="'value'"
                    [autoDisplayFirst]="false">
                    <ng-template #item let-data>
                        {{ ('form.dekn.' + key + 'Options.' + data.name) | translate }}
                    </ng-template>
                    <ng-template #selectedItem let-data>
                        {{ ('form.dekn.' + key + 'Options.' + data.name) | translate }}
                    </ng-template>
                </app-select-input>
            }

            @if (form.controls['otherIllnesses'].value < 4) {
                <app-text-input
                    id="otherIllnessesText"
                    [form]="form"
                    label="form.dekn.otherIllnesses"
                    class="fr-2"
                ></app-text-input>
            }

            @for (key of keys.slice(4); track key) {
                <app-select-input
                    [id]="key"
                    [form]="form"
                    [staticOptions]="options"
                    [label]="'form.dekn.fields.' + key"
                    [valueKey]="'value'"
                    [autoDisplayFirst]="false">
                    <ng-template #item let-data>
                        {{ ('form.dekn.' + key + 'Options.' + data.name) | translate }}
                    </ng-template>
                    <ng-template #selectedItem let-data>
                        {{ ('form.dekn.' + key + 'Options.' + data.name) | translate }}
                    </ng-template>
                </app-select-input>
            }
        </div>

        <div class="grid-2col_auto input-grid-gaps">
            <div class="fr-2 font-bold">{{ 'form.finalEvaluation' | translate }}</div>
            <app-text-area-input
                id="note"
                [form]="form"
                label="form.dekn.fields.note"
                class="fr-2"
            ></app-text-area-input>

            <div>{{ 'form.totalPoints' | translate }}:</div>
            <div class="font-bold">{{ totalPoints }}</div>

            <div class="fr-2">{{ 'form.dekn.note' | translate }}</div>

            <div>{{ 'form.dekn.dependency' | translate }}:</div>
            <div class="font-bold">{{ finalEvaluation }}</div>
        </div>

        <div class="grid-4col input-grid-gaps">
            <div class="fr-4 font-bold">{{ 'form.administration' | translate }}</div>
            <app-select-input
                [form]="form"
                id="user"
                [infiniteScroll]="store.userScroll()"
                valueKey="id"
                label="form.dekn.fields.user"
            >
                <ng-template #item let-item>
                    {{ item | formatPerson }}
                </ng-template>
                <ng-template #selectedItem let-item>
                    {{ item | formatPerson }}
                </ng-template>
            </app-select-input>
            <app-date-input
                id="date"
                [form]="form"
                label="form.dekn.fields.date"
            ></app-date-input>
        </div>

        <app-action-buttons
            [primaryButtonVisibility]="form.enabled"
            (primaryClickEvent)="submit()"
            (secondaryClickEvent)="closeForm.emit()"
        ></app-action-buttons>
    </div>
}
